export function getActiveSalesPrice(variant) {
    if(variant.abcKategorie === 'A' || variant.abcKategorie === 'B') {
        if (variant.aktionsPreisPickup && variant.isPickUpOfferActive) {
            return variant.aktionsPreisPickup;
        } else{
            return variant.pickup_preis ?? 0;
        }
    }

    if (variant.aktionsPreis && variant.isDeliveryOfferActive) {
        return variant.aktionsPreis;
    } else {
        return variant.vk_preis ?? 0;
    }
}

export function getActiveSalesPriceProduct(product, isOfferActive) {
    if(product.preisAb && product.originalPrice && product.preisAb !== product.originalPrice && isOfferActive) {
        return product.preisAb;
    } else {
        return product.originalPrice ?? product.preisAb ?? 0;
    }
}

const VALID_GTIN_LENGTHS = [8, 12, 13, 14];

export function gtinToJsonLd({ gtin }) {
    if (!gtin) return;
    const { length } = gtin;
    if (!VALID_GTIN_LENGTHS.includes(length)) return;
    return {
        [`gtin${length}`]: gtin,
    };
}
